module.exports = {"621226100":"城关镇","621226101":"盐官镇","621226102":"石桥镇","621226103":"白河镇","621226104":"宽川镇","621226105":"永兴镇","621226106":"祁山镇","621226107":"红河镇","621226108":"永坪镇","621226109":"中坝镇","621226110":"罗坝镇","621226111":"雷坝镇","621226112":"崖城镇","621226113":"洮坪镇","621226114":"龙林镇","621226203":"马河乡","621226209":"固城乡","621226212":"湫山乡","621226215":"上坪乡","621226218":"江口乡","621226219":"雷王乡","621226222":"白关乡","621226224":"沙金乡","621226227":"桥头乡","621226228":"草坪乡","621226230":"王坝乡","621226231":"肖良乡","621226232":"三峪乡","621226233":"滩坪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621226.json
// module id = 2747
// module chunks = 0